module.exports = __webpack_public_path__ + "img/xls-icon.c9333517.svg";